import {AnimatedFitoImage} from "../molecules/animated-fito.molcule.jsx";
import CustomText from "../atoms/custom-text.atom.jsx";

export const LoadingFitoTemplate = () => {
    return (
        <div style={{width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '32px'}}>
            <AnimatedFitoImage/>
            <CustomText variant={'headlineXl'}>Cargando...</CustomText>
        </div>
    )
}